import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// CSS Import
import "./index.css";

// REDUX Import
import { setCurrentMenu } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

// MENU Import
import MenuItemCardmobile from "../../MenuItemCardmobile";

// UTLIS Imports
import checkIfEnable from "../../../../utils/checkIfEnable";

// SERVICES Import
import ServiceIDByLabel from "../../../../services/ServiceIDByLabel";

export default function MobileViewPopover(props) {
  // useDispatch
  const dispatch = useDispatch();

  // useRef
  const elementRef = useRef(null);

  // useState
  const [flowType, setFlowType] = useState(false);
  const [isPopoverClosing, setIsPopoverClosing] = useState(false);

  // useSelector
  const services_list = useSelector((state) => state.refreshToken.services);
  const setOpenMobilePopover = props.setOpenMobilePopover;

  // useEffect
  useEffect(() => {
    setFlowType(
      props.data[0].title.includes("Transaction") ? "Transactions" : "Accounts",
    );
  }, []);

  const handleTogglePopover = () => {
    setIsPopoverClosing(true);
    setTimeout(() => {
      setOpenMobilePopover(false);
      setIsPopoverClosing(false);
    }, 200);
  };

  const hidePopover = () => {
    setIsPopoverClosing(true);
    setTimeout(() => {
      setOpenMobilePopover(false);
      setIsPopoverClosing(false);
    }, 200);
  };

  return (
    <div>
      <div
        onClick={() => {
          hidePopover();
        }}
        className="overlay absolute"
      ></div>
      {["bottom"].map((anchor) => (
        <div
          ref={elementRef}
          className={`popover-main-mobile relative py-padding_mb ${
            isPopoverClosing ? "closing" : "open"
          }`}
        >
          <div
            className="menudiv"
            style={{
              width: "var(--width-full)",
              boxShadow: "none",
              margin: "auto",
              flexGrow: 1,
              height: "auto",
              cursor: "pointer",
            }}
          >
            <>
              {props.data.map((transaction, index) =>
                transaction.title !== "Admin Transactions" ? (
                  <>
                    <div className="mt-margin-md mb-margin-md px-padding-md text-text-primary text-font-md font-semibold">
                      {transaction.title.toUpperCase()}
                    </div>
                    <div>
                      {transaction.menuItems.map((menuItem, index) => (
                        <Link
                          to={`/${menuItem.route}`}
                          style={{
                            "textDecoration": "none",
                            "pointerEvents": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? "auto"
                              : "none",
                            "backgroundColor": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? "var(--text-primary)"
                              : "var(--text-secondary)",
                            "&:hover": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            ) && {
                              backgroundColor: "var(--text-primary)",
                              cursor: "pointer",
                            },
                            "opacity": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? "var(--base-opacity)"
                              : "var(--light-opacity)",
                          }}
                          onClick={() => {
                            dispatch(setCurrentMenu(menuItem.menu));
                            handleTogglePopover();
                          }}
                        >
                          <MenuItemCardmobile
                            key={index}
                            icon={menuItem.icon}
                            labelm={menuItem.labelm}
                            labela={menuItem.labela}
                          />
                        </Link>
                      ))}
                    </div>
                    <div
                      key={index}
                      style={{
                        fontSize: "var(--font-xs)",
                        color: "var(--text-secondary)",
                        padding: "var(--padding-base) var(--padding-md)",
                        marginBottom: "var(--margin-md)",
                      }}
                    >
                      *If disabled - the feature is not available for your ID.
                    </div>
                  </>
                ) : null,
              )}
            </>
          </div>
        </div>
      ))}
    </div>
  );
}
